import universe_flat from "$root/assets/images/create-dialog[preload]/universe-flat.svg";
import universe_groups from "$root/assets/images/create-dialog[preload]/universe-groups.svg";
import { typedUrlForRoute } from "$root/components/PlatformRouter/RoutesDef";
import { ManualCreationEntitiesEnum } from "$root/pages/ManualCreation/common";
import type { SpawnResult } from "@mdotm/shadcn/legacy/react-extensions";
import { spawnMultipleChoiceCreationDialog } from "./MultipleChoiceCreationDialog";

export function spawnUniverseCreationDialog({ intentId }: { intentId?: string }): SpawnResult<void> {
	return spawnMultipleChoiceCreationDialog({
		options: [
			{
				href: typedUrlForRoute("Portfolios/ManualCreation", { entity: ManualCreationEntitiesEnum.Universe, intentId }),
				"data-qualifier": "PortfolioStudio/Universe/NewUniverse",
				icon: universe_flat,
				title: "Universe",
				description: "Define lists of instruments to use for portfolio construction.",
			},
			{
				href: typedUrlForRoute("EditUniverseWithGroups", {
					universeUuidOrNew: "new",
					intentId,
				}),
				"data-qualifier": "PortfolioStudio/Universe/NewUniverseWithGroups",
				icon: universe_groups,
				title: "Universe with groups",
				description:
					"Organize instruments into sub-groups with defined weights to guide portfolio construction and selection.",
			},
		],
	});
}
